const PROD_API_BASE_URL = 'https://568ch3su58.execute-api.eu-west-1.amazonaws.com/Main/paygap';

const isLocalhost = typeof window !== 'undefined'
  && ['localhost', '127.0.0.1'].includes(window.location.hostname);

// In local development, use CRA proxy to avoid browser CORS issues.
// In deployed environments, call API Gateway directly.
export const API_BASE_URL = isLocalhost ? '/paygap' : PROD_API_BASE_URL;
